import type { SVGProps } from 'react';
import * as React from 'react';
const SvgIconReset = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.192 4.86c.17 1.26.331 1.938.734 3.087 1.208-.157 1.885-.318 3.088-.734m3.208 10.908A8.407 8.407 0 1 0 2.278 7.824"
    />
  </svg>
);
export default SvgIconReset;
